import { FileArchive, FileImage, FileMusic, FileSpreadsheet, FileText, FileType2, FileVideo, Presentation, File as FileGeneric } from 'lucide-react';
import { fileIconKind } from '@kaba/shared';

/** Symbol je Dateiart (0.91) – Kacheln und Listen ohne Vorschaubild */
export function FileIcon({ mime, filename, isImage = false, size = 24 }: { mime: string; filename: string; isImage?: boolean; size?: number }) {
  const k = fileIconKind({ mime, filename, isImage });
  const Icon =
    k === 'pdf' ? FileType2
    : k === 'word' || k === 'text' ? FileText
    : k === 'sheet' ? FileSpreadsheet
    : k === 'slides' ? Presentation
    : k === 'video' ? FileVideo
    : k === 'audio' ? FileMusic
    : k === 'image' ? FileImage
    : k === 'archive' ? FileArchive
    : FileGeneric;
  return <Icon size={size} aria-hidden />;
}
